import { gql } from '@apollo/client';
import {
  errorFragmentStr,
  textPairFragmentStr,
  addressFragmentStr,
  basicAddressFragmentStr,
  shippingDetailsFragmentStr,
  billingInfoItemFragmentStr,
  billingInfoFragmentStr,
  vatDutyDetailsFragment,
  orderDetailsItemFragmentStr,
  transactionRowFragmentStr,
  transactionSummaryFragmentStr,
  orderItemsContainerFragmentStr,
  shippingAddressFragmentStr,
  stepFourFragmentStr,
  stepTwoFragmentStr,
  nextStepsFragmentStr,
  rneProductsFragmentStr,
  rneItemFragmentStr,
  productFragmentStr,
  wssPaymentDetailsFragmentStr,
} from '../../query/fragmentStrings';
import { labelValuePairFragment } from '../../query/fragments';

export const ORDER_DETAILS_QUERY = gql`
  query ORDER_DETAILS_QUERY($orderId : ID!, $email : String, $channel: String, $placedTime: String) {
    orderDetails(orderId : $orderId, email: $email, channel: $channel, placedTime: $placedTime) {
      orderDetailItems {
        ...orderDetailsItem
        ...orderItemsContainer
      }
      success
      errors { ...error }
    }
    textFor {
      pleaseTryAgain: pair(pairKey: "pleaseTryAgain") { ...textPair }
      processingText: pair(pairKey: "processing") { ...textPair }
      successText: pair(pairKey: "success") { ...textPair }
      rneSummaryTitleText: pair(pairKey: "summaryText") { ...textPair }
      invalidOrderHeader: pair(pairKey: "invalidOrderHeader") { ...textPair }
      errorInvalidOrderContent: pair(pairKey: "errorInvalidOrderContent") { ...textPair }
    }
  }

  ${textPairFragmentStr}
  ${errorFragmentStr}
  ${labelValuePairFragment}
  ${addressFragmentStr}
  ${basicAddressFragmentStr}
  ${shippingDetailsFragmentStr}
  ${billingInfoItemFragmentStr}
  ${billingInfoFragmentStr}
  ${vatDutyDetailsFragment}
  ${orderDetailsItemFragmentStr}
  ${transactionRowFragmentStr}
  ${transactionSummaryFragmentStr}
  ${orderItemsContainerFragmentStr}
  ${shippingAddressFragmentStr}
  ${stepFourFragmentStr}
  ${stepTwoFragmentStr}
  ${nextStepsFragmentStr}
  ${rneProductsFragmentStr}
  ${rneItemFragmentStr}
  ${productFragmentStr}
  ${wssPaymentDetailsFragmentStr}
`;

export const RESEND_ORDER_CONFIRMATION_QUERY = gql`
 query RESEND_ORDER_CONFIRMATION_QUERY
  ($orderId: ID!, $isShipping: Boolean!, $packageNumber: String) {
    resendOrderConfirmation(orderId: $orderId, isShipping: $isShipping, packageNumber: $packageNumber) {
      status
    }
  }
`;

export const UPDATE_ORDER_PAYMENT = gql`
  ${textPairFragmentStr}
  
  mutation UpdateOrderPayment($input: UpdatePaymentInput!) {
    updateOrderPayment(input: $input) {
      success
      userMessage { ...textPair }
      updatedOrderStatus
    }
  }
`;

export const COUNTRY_LIST_QUERY = gql`
  query CountryList {
    countryList {
      id
      code
      value
      label
      key
    }
  }
`;

export const STATE_LIST_QUERY = gql`
  query StateList($country: String!) {
    stateList(country: $country) {
      id
      label {
        key
        value
      }
    }
  }
`;

export const WSS_PAYMENT_FORM_ERROR_MESSAGES_QUERY = gql`
  query WssPaymentFormErrorMessages {
    wssPaymentFormErrorMessages {
      cardNumberError {
        key
        value
      }
      expiryError {
        key
        value
      }
      cvvError {
        key
        value
      }
      countryError {
        key
        value
      }
      firstNameError {
        key
        value
      }
      lastNameError {
        key
        value
      }
      addressError {
        key
        value
      }
      cityError {
        key
        value
      }
      postalCodeError {
        key
        value
      }
    }
  }
`;
